import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import GetAppIcon from '@material-ui/icons/GetApp'
import { getRequest, postRequest } from '../../globalhelper/helper'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import ErrorIcon from '@mui/icons-material/Error';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RefreshIcon from '@mui/icons-material/Refresh';
import _ from 'lodash'
import '../CI/COD.css'
import VR2_Forms from '../../pages/VR2_Form_Rendering/displayContainer'
import {
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Button,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Table,
    Paper,
    TableHead,
    AlertTitle,
    Alert,
    Box,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Collapse,
    Stepper,
    Step,
    StepLabel,
    StepContent
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import moment from 'moment'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { CSVLink } from 'react-csv'

const Row = ({ item, handleVendor }) => {
    const [open, setOpen] = useState(false);

    let journeySteps = [];
    try {
        if (item.process_journey) {
            journeySteps = typeof item.process_journey === 'string' ? JSON.parse(item.process_journey) : item.process_journey;
            journeySteps = journeySteps.map(step => typeof step === 'string' ? JSON.parse(step) : step);
        }
    } catch (e) { console.error("Error parsing process_journey in Row:", e); }

    if (!journeySteps || journeySteps.length === 0) {
        const currentStatus = (item['vendor_status'] || '').toUpperCase();

        // 1. Always start with Invited
        journeySteps.push({
            step: 'Invited',
            status: 'Success',
            date: moment().format('DD/MM/YYYY hh:mm A') || ''
        });

        // 2. Determine Submitted Step
        if (currentStatus === 'INVITED' || !currentStatus) {
            journeySteps.push({ step: 'Submitted', status: 'Pending', date: '' });
        } else {
            journeySteps.push({ step: 'Submitted', status: 'Success', date: item['submission_date'] || item['created_at'] || '' });
        }

        // 2.5 Insert dynamic "Request for changes" if that is the current state
        if (currentStatus === 'REQUEST FOR CHANGES' || currentStatus === 'CHANGES REQUESTED') {
            journeySteps.push({ step: 'Request for Changes', status: 'Pending', date: item['updated_at'] || '' });
        }

        // 3. Determine Approved/Rejected Final Step
        if (currentStatus === 'APPROVED') {
            journeySteps.push({ step: 'Approved', status: 'Approved', date: item['approval_date'] || item['updated_at'] || '' });
        } else if (currentStatus === 'REJECTED') {
            journeySteps.push({ step: 'Rejected', status: 'Rejected', date: item['approval_date'] || item['updated_at'] || '' });
        } else {
            journeySteps.push({ step: 'Approved / Rejected', status: 'Pending', date: '' });
        }
    }

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                    {(() => {
                        let isEnabled = false;
                        try {
                            if (item.process_journey) {
                                let journey = typeof item.process_journey === 'string' ? JSON.parse(item.process_journey) : item.process_journey;
                                if (Array.isArray(journey)) {
                                    journey = journey.map(step => typeof step === 'string' ? JSON.parse(step) : step);
                                    const submittedStep = journey.find(j => (j.step === 'Submitted' || j.action === 'Submitted') && (j.status === 'Completed' || j.status === 'Success' || j.status === 'Approved'));
                                    if (submittedStep) isEnabled = true;
                                }
                            } else {
                                // Fallback
                                if (item['vendor_status'] && (item['vendor_status'].toUpperCase() === 'SUBMITTED' || item['vendor_status'].toUpperCase() === 'COMPLETED')) {
                                    isEnabled = true;
                                }
                            }
                        } catch (e) {
                            console.error("Error parsing process_journey:", e);
                        }

                        return isEnabled ? (
                            <Button
                                variant='text'
                                color='primary'
                                onClick={() => handleVendor(item)}
                            >
                                {item['id']}
                            </Button>
                        ) : (
                            item['id']
                        );
                    })()}
                </TableCell>
                <TableCell sx={{ whiteSpace: 'normal' }}>
                    {item['vendor_name']}
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                    {item['emailid']}
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                    {item['submission_date'] ? moment(item['submission_date']).format('DD/MM/YYYY') : ''}
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                    {item['vendor_status']}
                </TableCell>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: open ? 'none' : undefined }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ backgroundColor: '#f9fafb', px: 2, borderRadius: 1, border: '1px solid #e5e7eb' }}>
                            <Stepper alternativeLabel sx={{
                                p: 0,
                                '& .MuiStepLabel-root': { py: 0.2 },
                                '& .MuiStepConnector-line': { marginTop: '-4px' },
                                '& .MuiStepIcon-root': { width: '16px', height: '16px' }
                            }}>
                                {journeySteps.map((stepRow, index) => {
                                    const stepName = stepRow.step || stepRow.action;
                                    const status = stepRow.status || 'Completed';
                                    const dateStr = stepRow.date || stepRow.timestamp ? moment(stepRow.date || stepRow.timestamp).format('DD/MM/YYYY hh:mm A') : 'N/A';

                                    let activeState = false;
                                    let completedState = false;
                                    let errorState = false;

                                    if (status.toLowerCase() === 'completed' || status.toLowerCase() === 'approved' || status.toLowerCase() === 'success') {
                                        completedState = true;
                                    } else if (status.toLowerCase() === 'rejected' || status.toLowerCase() === 'error') {
                                        activeState = true;
                                        errorState = true;
                                    } else if (status.toLowerCase() === 'processing') {
                                        activeState = true;
                                    } else if (status.toLowerCase() === 'pending') {
                                        activeState = false;
                                    }

                                    const CustomStepIcon = (props) => {
                                        const { error } = props;
                                        if (error) return <ErrorIcon color="error" sx={{ fontSize: 20 }} />;
                                        if (completedState) return <CheckCircleIcon sx={{ color: '#2e7d32', fontSize: 20 }} />;
                                        if (status.toLowerCase() === 'processing') return <CircularProgress size={16} sx={{ color: '#0ea5e9' }} />;
                                        return <RadioButtonUncheckedIcon color="disabled" sx={{ fontSize: 20 }} />;
                                    };

                                    return (
                                        <Step key={index} active={activeState} completed={completedState}>
                                            <StepLabel
                                                error={errorState}
                                                StepIconComponent={CustomStepIcon}
                                            >
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.75rem', lineHeight: 1.1 }}>{stepName}</Typography>
                                                <Typography color="textSecondary" sx={{ fontSize: '0.65rem', lineHeight: 1 }}>{status}</Typography>
                                            </StepLabel>
                                        </Step>
                                    );
                                })}
                            </Stepper>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
};

const VendorRegistration = props => {
    const [showtable, setShowtable] = useState(false);
    const [formData, setFormData] = useState({
        vendorname: '',
        vendoremail: '',
        status: '',
        period: null,
        orgid: ''
    })
    const [tableData, setTableData] = useState([])
    const [displayData, setDisplayData] = useState([])
    const [dropdown_vendorname, setDropdownVendorname] = useState([])
    const [dropdown_vendoremail, setDropdownVendoremail] = useState([])
    const [dropdown_status, setDropdownStatus] = useState([])
    const [dropdown_orgname, setDropdownOrgname] = useState([])
    const [redirect, setRedirect] = useState(false)
    const [SearchJSON, setSearchJSON] = useState([])
    const [openEmailDialog, setOpenEmailDialog] = useState(false)
    const [inputEmail, setInputEmail] = useState('')
    const [inputName, setInputName] = useState('')
    const [inputSubject, setInputSubject] = useState('')
    const [inputMessage, setInputMessage] = useState('')
    const [id, setId] = useState('')
    const emailContentRef = useRef(null)

    const [isSending, setIsSending] = useState(false)
    const [isRefreshing, setIsRefreshing] = useState(false)

    const sendInvitationApiCall = (email, name, subject, message) => {
        setIsSending(true);
        postRequest('api/vr2/sendVPInvitation', {
            vendorname: name,
            orgid: localStorage.getItem('tenant_id'),
            email: email,
            subject: subject,
            message: message,
            id: id
        }).then(res => {
            if (res.res.status === 'success') {
                console.log(res.res);
                setOpenEmailDialog(false)
                setInputEmail('')
                setInputName('')
                setInputSubject('')
                setInputMessage('')
            } else {
                console.log(res.res);
            }
        }).catch(err => {
            console.log(err);
        }).finally(() => {
            setIsSending(false);
            get_processData()
        });
    }

    const emailStyles = `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');
        .email-preview-container { margin: 0; padding: 40px 20px; background: linear-gradient(135deg, #e0f2fe 0%, #f0fdf4 100%); font-family: 'Inter', sans-serif; }
        .email-preview-container .email-container { max-width: 650px; margin: 0 auto; background-color: #ffffff; border-radius: 16px; overflow: hidden; box-shadow: 0 10px 40px rgba(0, 31, 63, 0.08); border: 1px solid rgba(135, 206, 235, 0.2); }
        .email-preview-container .header { background: linear-gradient(135deg, #001f3f 0%, #003366 100%); color: #ffffff; padding: 40px 30px; text-align: center; border-bottom: 6px solid #87CEEB; }
        .email-preview-container .header-title { font-size: 28px; font-weight: 700; margin: 0; letter-spacing: 1px; }
        .email-preview-container .header-subtitle { font-size: 15px; color: #87CEEB; margin-top: 8px; font-weight: 400; }
        .email-preview-container .content { padding: 40px; color: #334155; line-height: 1.8; font-size: 16px; outline: none; }
        .email-preview-container .content p { margin-bottom: 20px; }
        .email-preview-container .button-container { text-align: center; margin: 45px 0; }
        .email-preview-container .accept-button { background: linear-gradient(to right, #87CEEB, #0ea5e9); color: #ffffff !important; padding: 18px 40px; text-decoration: none; font-size: 18px; border-radius: 50px; display: inline-block; font-weight: 600; box-shadow: 0 8px 20px rgba(14, 165, 233, 0.3); cursor: pointer; transition: transform 0.2s ease, box-shadow 0.2s ease; }
        .email-preview-container .accept-button:hover { transform: translateY(-2px); box-shadow: 0 10px 25px rgba(14, 165, 233, 0.4); }
        .email-preview-container .footer { background-color: #f8fafc; padding: 30px; font-size: 13px; color: #64748b; text-align: center; border-top: 1px solid #e2e8f0; }
        .email-preview-container .link { word-break: break-all; color: #0ea5e9; font-weight: 600; text-decoration: none; }
        .email-preview-container .highlight-box { background-color: #f0f9ff; border-left: 4px solid #87CEEB; padding: 15px 20px; border-radius: 0 8px 8px 0; margin: 25px 0; color: #001f3f; }
    `;

    const getEmailInnerHtml = (vendorName, id) => `
        <div class="header" contenteditable="false">
            <h1 class="header-title">DataTwin.ai</h1>
            <div class="header-subtitle">Vendor Registration Invitation</div>
        </div>
        <div class="content" contenteditable="true">
            <p style="font-size: 18px; font-weight: 600; color: #001f3f;">Dear ${vendorName ? vendorName : 'Vendor'},</p>
            <p>You have been exclusively invited to join our network and complete your vendor registration. We are thrilled to have you onboard.</p>
            
            <div class="highlight-box" contenteditable="false">
                <strong>Action Required:</strong> Please click the button below to securely access your registration portal.
            </div>

            <div class="button-container" contenteditable="false">
                <a target="_blank" href="https://vp-dev.d1qtjia2b8rdgu.amplifyapp.com/pages/registration/${id}" class="accept-button">Complete Registration</a>
            </div>

            <p>If the button above does not work, you can copy and paste the following secure link into your browser:</p>
            <p><strong>Security Note:</strong> This personalized link is unique to you and will automatically expire in 7 days to ensure your data's safety.</p>
            <p>If you did not request this invitation, please disregard this email.</p>
            
            <p style="margin-top: 40px;">Best Regards,<br><strong style="color: #0ea5e9;">The Support Team</strong></p>
        </div>
        <div class="footer" contenteditable="false">
            <p style="margin: 0; margin-bottom: 10px;"><strong>DataTwin.ai</strong> | Empowering your business</p>
            <p style="margin: 0;">© 2026 Your Company. All rights reserved.</p>
        </div>
    `;

    const handleDialogSubmit = () => {
        if (inputName && inputEmail) {
            let finalMessage = inputMessage;
            if (emailContentRef.current) {
                finalMessage = emailContentRef.current.innerHTML;
            }

            const fullHtml = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>Vendor Registration Invitation</title>
    <style>
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');
        body { margin: 0; padding: 40px 20px; background: linear-gradient(135deg, #e0f2fe 0%, #f0fdf4 100%); font-family: 'Inter', sans-serif; }
        .email-container { max-width: 650px; margin: 0 auto; background-color: #ffffff; border-radius: 16px; overflow: hidden; box-shadow: 0 10px 40px rgba(0, 31, 63, 0.08); border: 1px solid rgba(135, 206, 235, 0.2); }
        .header { background: linear-gradient(135deg, #001f3f 0%, #003366 100%); color: #ffffff; padding: 40px 30px; text-align: center; border-bottom: 6px solid #87CEEB; }
        .header-title { font-size: 28px; font-weight: 700; margin: 0; letter-spacing: 1px; }
        .header-subtitle { font-size: 15px; color: #87CEEB; margin-top: 8px; font-weight: 400; }
        .content { padding: 40px; color: #334155; line-height: 1.8; font-size: 16px; }
        .content p { margin-bottom: 20px; }
        .button-container { text-align: center; margin: 45px 0; }
        .accept-button { background: linear-gradient(to right, #87CEEB, #0ea5e9); color: #ffffff !important; padding: 18px 40px; text-decoration: none; font-size: 18px; border-radius: 50px; display: inline-block; font-weight: 600; box-shadow: 0 8px 20px rgba(14, 165, 233, 0.3); }
        .footer { background-color: #f8fafc; padding: 30px; font-size: 13px; color: #64748b; text-align: center; border-top: 1px solid #e2e8f0; }
        .link { word-break: break-all; color: #0ea5e9; font-weight: 600; text-decoration: none; }
        .highlight-box { background-color: #f0f9ff; border-left: 4px solid #87CEEB; padding: 15px 20px; border-radius: 0 8px 8px 0; margin: 25px 0; color: #001f3f; }
    </style>
</head>
<body>
    <div class="email-container">
        ${finalMessage}
    </div>
</body>
</html>`;
            sendInvitationApiCall(inputEmail, inputName, inputSubject, fullHtml);
        }
    };

    const get_processData = () => {
        setIsRefreshing(true);
        getRequest(`api/edureka/getVMRData`).then(res => {
            if (res.res.status === 'success') {
                let temp = JSON.parse(res.res.data);
                console.log(temp);
                setTableData(temp)
                setDisplayData(temp)
                setShowtable(true)
                let temp1 = temp.map(value => value['vendor_name']);
                let vendorname = [...new Set(temp1)]?.sort((a, b) => a.localeCompare(b));
                console.log(vendorname);
                let tempE = temp.map(value => value['emailid']);
                let temE = tempE.filter(value => value);
                let vendoremail = [...new Set(temE)]?.sort((a, b) => a.localeCompare(b));
                let tempSt = temp.map(value => value['vendor_status']);
                let tempSt1 = tempSt.filter(value => value);
                let status = [...new Set(tempSt1)]?.sort((a, b) => a.localeCompare(b));
                setDropdownVendorname(vendorname);
                setDropdownVendoremail(vendoremail);
                setDropdownStatus(status);
            } else {
                console.log('No Data');
            }
        }).finally(() => {
            setIsRefreshing(false);
        });
    }
    useEffect(() => {
        sessionStorage.setItem('pageName', 'Search Vendors Onboarding');
        get_processData();
        const intervalId = setInterval(() => {
            get_processData();
        }, 30000);
        getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
            const responseData = response.res.data;
            const arr = responseData.map(item => ({ orgname: item.orgname, orgid: item.orgid }));
            setDropdownOrgname(arr);
            if (arr && arr.length == 1) {
                handleChange('orgid', arr[0]?.orgid);
            }
        }).catch(err => console.log(err));
        return () => clearInterval(intervalId);
    }, []);
    const handleChange = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value || ''
        }));
    };

    useEffect(() => {
        if (!formData.period) return;

        // if your period is '2025-10'
        const startDate = moment(formData.period, 'YYYY-MM').startOf('month');
        const endDate = moment(formData.period, 'YYYY-MM').endOf('month');
        const filtered = tableData.filter(item => {
            // parse with correct format (DD/MM/YYYY)
            const itemDate = moment(item?.[''], ['YYYY-MM-DDTHH:mm:ss.SSSZ', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD', 'DD/MM/YYYY'], true);
            return itemDate.isSameOrAfter(startDate) && itemDate.isSameOrBefore(endDate);
        });
        // console.log(filtered)

        setDisplayData(filtered);
    }, [formData.period, tableData]);
    const handleVendor = i => {
        const vendorid = i['id'] || i['Vendor ID'];
        localStorage.setItem('selectedItem', JSON.stringify(i));
        localStorage.setItem('api', `api/edureka/getJSONViaKey?docId=${vendorid}&companyid='NoLDE'&key=preloadedscreen/registration/${vendorid}.json`);
        window.open(`/Dynamic_Forms?token=VendorMaster&action=edit&orgId=NoLDE&docId=${vendorid}`, '_blank');
    };

    const handleReset = () => {
        setShowtable(false);
        setFormData({
            vendorname: '',
            vendoremail: '',
            status: '',
            period: null,
            orgid: ''
        });
    };

    const onBack = () => {
        setRedirect(false);
        setSearchJSON([]);
    };
    if (redirect) {
        return <VR2_Forms screenName={'VendorMaster'} screenAction={'edit'} From_SearchJSON={SearchJSON} onBack={onBack} />;
    }
    return <>
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel3-content' id='panel3-header'>
                <Typography variant='h6'>Search Vendor Master</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid spacing={3} container>
                    <Grid item xl={2}>
                        <Autocomplete fullWidth options={dropdown_orgname} getOptionLabel={(option) => option.orgname || ''} isOptionEqualToValue={(option, value) => option.orgid === value} value={dropdown_orgname.find(option => option.orgid === formData.orgid) || null} onChange={(e, newValue) => handleChange('orgid', newValue ? newValue.orgid : '')} renderInput={params => <TextField {...params} label='Organization Name' variant='outlined' size='small' />} />
                    </Grid>
                    {formData.orgid && (<>
                        <Grid item xl={2}>
                            <Autocomplete fullWidth label='Vendor Name' name='vendorname' value={dropdown_vendorname.find(option => option === formData.vendorname) || ''} onChange={(e, newValue) => handleChange('vendorname', newValue)} options={dropdown_vendorname} renderInput={params => <TextField {...params} label='Vendor Name' name='vendorname' variant='outlined' size='small' fullWidth />} />
                        </Grid>
                        <Grid item xl={2}>
                            <Autocomplete fullWidth value={dropdown_vendoremail.find(option => option === formData.vendoremail) || ''} onChange={(e, newValue) => handleChange('vendoremail', newValue)} options={dropdown_vendoremail} renderInput={params => <TextField {...params} label='Vendor Email' name='vendoremail' variant='outlined' size='small' fullWidth />} />
                        </Grid>
                        <Grid item xl={2}>
                            <Autocomplete fullWidth options={dropdown_status} value={formData.status} onChange={(event, newValue) => {
                                handleChange('status', newValue);
                            }} renderInput={params => <TextField name='status' {...params} label='Status' variant='outlined' size='small' fullWidth />} />
                        </Grid></>)}
                    <Grid item xs={2} sm={3} md={5}>
                        <Button variant='contained' color='error' onClick={handleReset}>
                            Reset
                        </Button>
                        &nbsp;
                        <Button variant='contained' color='warning' onClick={() => props.onBack()}>
                            Back
                        </Button>
                        &nbsp;
                        <Button variant='contained' color='success' disabled={!formData?.orgid || formData.orgid == ''} onClick={() => {
                            let nameForTemplate = '';
                            const newId = crypto.randomUUID();
                            setId(newId);
                            if (formData.vendoremail) {
                                setInputEmail(formData.vendoremail);
                            }
                            if (formData.vendorname) {
                                setInputName(formData.vendorname);
                                nameForTemplate = formData.vendorname;
                            }
                            setInputMessage(getEmailInnerHtml(nameForTemplate, newId));
                            setInputSubject('Vendor Registration Invitation');
                            setOpenEmailDialog(true);
                        }}>
                            Send Invite
                        </Button>
                    </Grid>
                </Grid>
                {tableData.length > 0 && formData.orgid && <>
                    <Typography variant='h6' mt={2}>
                        Filter
                    </Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={1} sm={2} md={4}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker label='Period' value={formData.period} views={['month', 'year']} onChange={newValue => {
                                    handleChange('period', newValue);
                                }} renderInput={params => <TextField fullWidth size='small' {...params} />} />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                </>}
            </AccordionDetails>
        </Accordion>

        {(showtable && tableData.length > 0 && formData.orgid) && (
            <div>
                <Box align='right' sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 1 }}>
                    <Button color='primary' variant='contained' onClick={get_processData} disabled={isRefreshing} startIcon={isRefreshing ? <CircularProgress size={20} color="inherit" /> : <RefreshIcon />}>
                        {isRefreshing ? 'Refreshing...' : 'Refresh'}
                    </Button>
                    <Button color='success' variant='contained'>
                        <CSVLink
                            style={{ color: 'white', textDecoration: 'none' }}
                            data={tableData}
                            filename='GRN.csv'
                        >
                            <GetAppIcon />
                        </CSVLink>
                    </Button>
                </Box>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>ID</TableCell>
                                <TableCell sx={{ whiteSpace: 'normal' }}>
                                    Vendor Name
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    Email ID
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    Submission Date
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    Vendor Status
                                </TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {displayData.length > 0 ? (
                                displayData
                                    .sort((a, b) => (a['id'] || '').localeCompare(b['id'] || ''))
                                    .map((item, index) => {
                                        return (
                                            <Row key={index} item={item} handleVendor={handleVendor} />
                                        )
                                    })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={5}>
                                        <Box sx={{ margin: 'auto' }}>
                                            <Alert severity='warning'>
                                                <AlertTitle>No Data Found</AlertTitle>
                                                There is no data to display at the moment.
                                            </Alert>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        )}

        <Dialog open={openEmailDialog} onClose={() => setOpenEmailDialog(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
            <DialogTitle sx={{ bgcolor: '#f4f6f8', pb: 2, fontWeight: 600 }}>New Message</DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', pt: '16px !important' }}>
                <TextField
                    margin="dense"
                    label="From"
                    type="text"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value="solve@datatwin.ai"
                    disabled
                />
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="To"
                        type="email"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={inputEmail}
                        onChange={(e) => setInputEmail(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        label="Vendor Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={inputName}
                        onChange={(e) => setInputName(e.target.value)}
                    />
                </Box>
                <TextField
                    margin="dense"
                    label="Subject"
                    type="text"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={inputSubject}
                    onChange={(e) => setInputSubject(e.target.value)}
                    sx={{ mb: 2 }}
                />
                <style>{emailStyles}</style>
                <div className="email-preview-container" style={{ border: '1px solid #ddd', borderRadius: 4, marginTop: 16, minHeight: 300, overflowY: 'auto' }}>
                    <div
                        className="email-container"
                        ref={emailContentRef}
                        dangerouslySetInnerHTML={{ __html: inputMessage }}
                    />
                </div>
            </DialogContent>
            <DialogActions sx={{ p: 2, bgcolor: '#f4f6f8' }}>
                <Button onClick={() => setOpenEmailDialog(false)} color="inherit" sx={{ mr: 1 }}>
                    Discard
                </Button>
                <Button
                    onClick={handleDialogSubmit}
                    color="primary"
                    variant="contained"
                    endIcon={<MailOutlineIcon />}
                    disabled={isSending || !inputName || !inputEmail || !inputEmail.toLowerCase().includes('@') || !inputEmail.toLowerCase().includes('.')}
                >
                    {isSending ? 'Sending...' : 'Send'}
                </Button>
            </DialogActions>
        </Dialog>
    </>;
};


const mapStateToProps = state => {
    return {
        userData: state.login.userData
    }
}

export default connect(mapStateToProps)(VendorRegistration)
